

























































































































































import { Component, Watch } from "vue-property-decorator";
import { mixins } from "vue-class-component";
import { DateRangeFilterMixin } from "@/mixins/DateRangeFilterMixin";
import StubCmp from "@/components/StubCmp.vue";

import { container } from "@/services/registerServiceProvider";
import { IReportService } from "@/services/IReportService";
import { Report } from "@/models/Report";
import { Agent } from "@/models/Agent";
import { SearchAgentsMixin } from "@/mixins/SearchAgentMixin";
import { searchProperties } from "@/models/SearchProperty";

@Component({
  components: { StubCmp },
})
export default class HomeOrderReports extends mixins(DateRangeFilterMixin, SearchAgentsMixin) {
  loading: boolean = true;
  reports: Report[] | null = null;
  stubText: string = "Данные для вашего профиля сейчас недоступны";
  private readonly reportService: IReportService = container.resolve(
    "IReportService",
  );
  agentSelected: string | Agent = "";

  @Watch("date", { deep: true, immediate: true })
  private async onDateChange() {
    if (this.date) {
      this.dateModal = [...this.date];
    }
  }

  created() {
    this.loadReports()
      .then(() => {
        setInterval(() => {
          this.updateStatuses();
        }, 30000);
      })
      .finally(() => {
        this.loading = false;
      });

    this.searchProperties = searchProperties;
    this.searchProperty = this.searchProperties[0];
  }

  get isAgentSelected() {
    return this.agentSelected instanceof Agent;
  }

  async updateStatuses() {
    if (this.reports?.filter(e => e.status === "waited").length) {
      await this.loadReports();
    }
  }

  async loadReports() {
    this.reports = await this.reportService.getList();
  }

  async downloadReport(reportId: number) {
    const file: Blob = await this.reportService.getFile(reportId);
    const a = document.createElement("a");

    a.href = URL.createObjectURL(file);
    a.download = `Отчет.xlsx`;
    a.click();
  }

  async downloadSegmentationReport() {
    if (this.agentSelected instanceof Agent  && this.dateModal?.length) {
      const file: Blob = await this.reportService.getSegmentationReport(this.agentSelected.id,  `${this.dateModal[0]} 00:00:00`, `${this.dateModal[1]} 23:59:59`, "ОтчетИзмененийСегментации");
      const a = document.createElement("a");

      a.href = URL.createObjectURL(file);
      a.download = `Отчет.xlsx`;
      a.click();
    } else {
      throw Error("You must fill out the searching agent field!")
    }

    this.searchStr = '';
    this.agentArray.splice(0);
    this.agentSelected = "";
  }

  async requestReport(reportType: string) {
    if (this.date && this.date.length === 2) {
      const find = this.reports?.find(e => e.type === reportType);

      if (find) {
        find.status = "waited";
      }

      await this.reportService.getRequest(
        this.date[0],
        this.date[1],
        reportType,
      );
    }
  }

  async searchUsers(val: string | Agent) {
    if (typeof val === "string") {
      this.agentArray.splice(0);
      this.agentSelected = "";
      this.searchStr = val;
      await this.searchAgent();
    }
  }
}
